import { BaseControlledModal } from "../../../../../../common/components/base_controlled_modal";
import DefaultInput from "../../../../../../common/components/default_input";
import { GestaoDistribuicaoEpi } from "../../../../domain/models/gestao_distribuicao_epi";

import dayjs from "dayjs";
import { GryfoAudit } from "../../../../domain/models/gryfo_audit";
type Props = {
  open: boolean;
  loading: boolean;
  imagemUrl: string | null;
  auditoriaGryfo: GryfoAudit | null;
  onClose: () => void;
};

export const VisualizacaoGryfoAuditaModal = ({
  open,
  loading,
  imagemUrl, 
  auditoriaGryfo,
  onClose,
}: Props) => {
  const formatarDataAuditoria = (timestamp?: number) => {
    return timestamp
      ? dayjs.unix(timestamp).format("DD/MM/YYYY [às] HH:mm:ss")
      : "-";
  };

  const isFraude = auditoriaGryfo?.gryfo_evaluation !== "NOT_A_FRAUD";

  const imgSrc = auditoriaGryfo?.imagemBase64
    ? `data:image/jpeg;base64,${auditoriaGryfo.imagemBase64}`
    : imagemUrl;

  return (
    <BaseControlledModal
      open={open}
      saving={false}
      loading={loading}
      title="Detalhes da Auditoria Biométrica"
      width="700px"
      onClose={onClose}
    >
      <div className="w-full flex flex-col gap-4 p-4 bg-gray-50 min-h-[300px] rounded-md mt-4">
        {loading ? (
          <span className="text-gray-500 text-center flex-1 flex items-center justify-center">
            Carregando dados da auditoria...
          </span>
        ) : auditoriaGryfo ? (
          <div className="flex flex-col md:flex-row gap-6 w-full">
            {/* LADO ESQUERDO: Imagem */}
            <div className="flex flex-col items-center w-full md:w-1/2">
              <div className="w-full bg-white p-2 rounded-md shadow-sm border border-gray-200 flex justify-center mb-2">
                {imgSrc ? (
                  <img
                    src={imgSrc}
                    alt="Biometria Auditada"
                    className="max-w-full max-h-[35vh] object-contain rounded-md"
                  />
                ) : (
                  <span className="text-gray-400 py-10">
                    Imagem indisponível
                  </span>
                )}
              </div>

              {/* Badge de Resultado Principal */}
              <div
                className={`w-full py-2 text-center rounded-md font-bold text-white shadow-sm ${
                  isFraude ? "bg-red-500" : "bg-green-500"
                }`}
              >
                {isFraude ? "⚠️ POSSÍVEL FRAUDE" : "✅ AUTÊNTICO (SEM FRAUDE)"}
              </div>
            </div>

            {/* LADO DIREITO: Dados Técnicos da Auditoria */}
            <div className="flex flex-col w-full md:w-1/2 gap-3">
              <h3 className="font-semibold text-gray-700 border-b pb-1">
                Informações de Segurança
              </h3>
              
              <div className="flex flex-col gap-1">
                <span className="text-xs text-gray-500">
                  Data e Hora do Reconhecimento
                </span>
                <span className="text-sm font-medium text-gray-800">
                  {formatarDataAuditoria(auditoriaGryfo.last_recognized)}
                </span>
              </div>

              <div className="flex flex-col gap-1">
                <span className="text-xs text-gray-500">
                  Matrícula Reconhecida
                </span>
                <span className="text-sm font-medium text-gray-800">
                  {auditoriaGryfo.external_id || "-"}
                </span>
              </div>

              {/* Box de Avisos / Qualidade */}
              {/* <div className="mt-2 bg-yellow-50 border border-yellow-200 p-3 rounded-md">
                <span className="text-xs font-bold text-yellow-700 block mb-1">
                  Avisos do Sistema:
                </span>
                <p className="text-xs text-yellow-800 mb-2">
                  {auditoriaGryfo.confidence_advice ||
                    "Nenhum aviso principal."}
                </p>

                {auditoriaGryfo.quality_info &&
                  auditoriaGryfo.quality_info.length > 0 && (
                    <>
                      <span className="text-xs font-bold text-yellow-700 block mb-1">
                        Qualidade da Imagem:
                      </span>
                      <ul className="list-disc pl-4 text-xs text-yellow-800">
                        {auditoriaGryfo.quality_info.map((info, index) => (
                          <li key={index}>{info}</li>
                        ))}
                      </ul>
                    </>
                  )}
              </div> */}
            </div>
          </div>
        ) : (
          <span className="text-gray-500 text-center flex-1 flex items-center justify-center h-full">
            Nenhum dado de auditoria encontrado.
          </span>
        )}
      </div>
    </BaseControlledModal>
  );
};
